export default function () {
  const initialState = {
    isLoading: true,
    isRefreshing: false
  };

  return initialState
}
